const filterNodes = {
  quickShopModal: document.querySelector('quick-shop'),
  parent: document.getElementById('collectionFilters'),
  gridsContainer: document.getElementById('products-listing'),
  collectionBanner: document.querySelector('[data-collectionBanner]'),
  subCollectionLinks: Array.from(document.getElementsByClassName('subcollection-links')),
  activeFilters: document.querySelector('[data-activeFilters]'),
  drawerFooter: document.querySelector('[data-filterFooter]'),
  openDrawerBtns: document.querySelectorAll('[data-openFilterDrawer]'),
  paginationParent: document.querySelector('[data-paginationParent]'),
  closeDrawer: document.querySelector('[data-closeDrawer]'),
  totalProductsCount: document.querySelector('[data-totalproducts]'),
  
}

// console.log(filterNodes.filterItems)

class CollectionFilters {
  constructor() {
    this.filterForm = filterNodes.parent.querySelector('form');
    filterNodes.parent.addEventListener('keyup', (event) => {
      if(event.code && event.code.toUpperCase() === 'ESCAPE') filterNodes.closeDrawer.dispatchEvent(new Event('click'));
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
      this.filterForm.addEventListener('input', (evt)=>{
        if((evt && evt.target.type == 'range') || window.innerWidth < 992) return false;
        this.debouncedOnSubmit(evt);
      });
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }
    this.bindCheckBoxEvent();
    this.bindEvents();
    this.dynamicEleEvents();
  }

  /**
   * bind dclick and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
  */
  bindEvents() {
    /** There are two open drawer buttons, one for Open filter drawer other for open sortby drawer **/
    if(filterNodes.openDrawerBtns.length > 0){
      filterNodes.openDrawerBtns.forEach(button => button.addEventListener('click', this.toggleFilterDrawer.bind(this)));
    }
    filterNodes.closeDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    let sortby_desktop = document.querySelectorAll('[data-sortByDesktop] .sortby_options');
    sortby_desktop.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    /** Only for horizontal filters - Close filters when clicked outside container **/
    const filterType = filterNodes.parent.dataset.filtertype;
    if(filterType == 'horizontal-filters'){
      document.body.addEventListener('click', (_event)=>{
        const openFilters = document.querySelectorAll('.filter__container.open');
        openFilters.forEach((target) => {
          target.querySelector('.tab_toggle').click();
        })
      });
  
      const filterContainers = document.querySelectorAll('.filter__container');
      filterContainers.forEach((target) => {
        target.addEventListener('click', (event)=>{
          event.stopPropagation();
        });
      });
    }

  }

  dynamicEleEvents() {
    /** Toggle each filter block container containing values for dropdown effect **/
    filterNodes.subCollectionLinks = Array.from(document.getElementsByClassName('subcollection-links'));
    filterNodes.subCollectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));

    if(filterNodes.quickShopModal && typeof filterNodes.quickShopModal.updateEvents == 'function'){ 
      filterNodes.quickShopModal.updateEvents(); 
    }

    const applyBtn = filterNodes.parent.querySelector('[data-applyFilters]');
    if(applyBtn){
      applyBtn.addEventListener('click', () => {
        const searchParams = this._createQueryString(this.filterForm)
        this.renderPage(searchParams);
      });
    }

    const paginationLinks = document.querySelectorAll('[data-pagelinks]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));
    
    
    this.colorOptionsStyling();
    this.bindActiveFilterButtonEvents();
  }

  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    const searchParams = this._createQueryString(this.filterForm)
    this.renderPage(searchParams);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _createQueryString(form){
    const formData = new FormData(form);
    if(form.querySelector('[name="filter.v.price.gte"]')){
      const priceGTE = form.querySelector('[name="filter.v.price.gte"]').min;
      const priceLTE = form.querySelector('[name="filter.v.price.lte"]').max;

      if(parseInt(formData.get('filter.v.price.gte')) == parseInt(priceGTE)){
        formData.delete('filter.v.price.gte');
      }
      if(parseInt(formData.get('filter.v.price.lte')) == parseInt(priceLTE)){
        formData.delete('filter.v.price.lte');
      }
    }
    return new URLSearchParams(Array.from(formData)).toString();
  }

  /**
   * 
   * @param {String} searchParams Query Parameters
   * @param {String} updateURLHash true/false
  */
  renderPage(searchParams, updateURLHash = true) {
    filterNodes.gridsContainer.classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = filterNodes.parent.querySelector('[data-colorFilter]');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    let URLString = new URL(event.currentTarget.href).searchParams.toString();
    if(URLString != null) this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, false);
  }

  /**
   * 
   * @param {String} url URL for fetching results
   * @param {String} type filter / pagination / sub_collection
   */
  renderGridFromFetch(url, type) {
    if(!url) return;

    let sectionID = document.getElementById('products-listing').dataset.id;
    if(type == 'sub_collection'){
      url += `&sections=${sectionID},template-collection-banner`;
    }else{
      url += `&sections=${sectionID}`;
    }
   
    fetch(url)
      .then(response => response.json())
      .then((response) => {
        let gridHTML = response[sectionID];
        let bannerHTML = response['template-collection-banner'];
        this.renderProductGrid(type, gridHTML, bannerHTML);
                
        window.yotpoWidgetsContainer.initWidgets();
      });
  }

  /**
   * 
   * @param {HTMlResponse} html 
   * @param {String} type filter / pagination / sub_collection
   */
  renderProductGrid(type, grid, banner) {
    const collectionParent = new DOMParser().parseFromString(grid, 'text/html');
    let paginationType = (filterNodes.paginationParent) ? filterNodes.paginationParent.dataset.type : 'numbers';

    if(type == 'pagination' && paginationType == 'loadmore'){
      let productGrids = filterNodes.gridsContainer.querySelector('#product-grids');
      productGrids.insertAdjacentHTML('beforeend', collectionParent.querySelector('#product-grids').innerHTML);

      let loadMoreBtn = document.getElementById('load-more');
      if(collectionParent.getElementById('load-more') && loadMoreBtn){   
        loadMoreBtn.parentNode.replaceChild(collectionParent.getElementById('load-more'), loadMoreBtn); 
      }else if(loadMoreBtn){
        loadMoreBtn.remove();
      }
    }else{
      const gridsHTML = collectionParent.getElementById('products-listing').innerHTML;
      filterNodes.gridsContainer.innerHTML = gridsHTML;
    }
    
    const filterPanels = collectionParent.querySelectorAll('#CollectionFiltersForm .filter__container');
    document.querySelectorAll('#CollectionFiltersForm .filter__container').forEach(panel => panel.classList.add('d-none'));
    filterPanels.forEach((panel)=> {
      let filterBlock = document.querySelector('.filter__container[data-index="'+panel.dataset.index+'"]');
      if(filterBlock){
        filterBlock.querySelector('.filter__block').innerHTML = panel.querySelector('.filter__block').innerHTML;
        filterBlock.classList.remove('d-none');
      }
    });

    filterNodes.drawerFooter.innerHTML = collectionParent.querySelector('[data-filterFooter]').innerHTML;

    const activeFilters = collectionParent.querySelector('[data-activeFilters]');
    if(activeFilters) filterNodes.activeFilters.innerHTML = activeFilters.innerHTML;
    this.dynamicEleEvents();

    // Change the product count
    if (filterNodes.totalProductsCount && collectionParent.querySelector('[data-totalproducts]')) filterNodes.totalProductsCount.innerHTML = collectionParent.querySelector('[data-totalproducts]').innerHTML;

    /******** Change banner on subcollection **********/
    if(type == 'sub_collection' && filterNodes.collectionBanner && banner){
      const bannerNode = new DOMParser().parseFromString(banner, 'text/html');
      let bannerHTML = bannerNode.querySelector('[data-collectionBanner]').innerHTML;
      filterNodes.collectionBanner.innerHTML = bannerHTML;
    }

    if(window.innerWidth <= 990){
       this.bindCheckBoxEvent();
    }
    document.querySelector(".content-for-layout").scrollIntoView(true);
    let drawerOpen = filterNodes.parent.classList.contains('filter-active');
    if(drawerOpen) filterNodes.closeDrawer.dispatchEvent(new Event('click'));
  }

  /**
   * Re-Binding events on active filters after ajax request
   */
  bindActiveFilterButtonEvents() {
    let removeActiveFilters = Array.from(document.getElementsByClassName('filter-option-clear'));
    removeActiveFilters.forEach((element) => element.addEventListener('click', this.onActiveFilterClick.bind(this), { once: true }));
  }

  bindCheckBoxEvent(){
    this.filterItems = filterNodes.parent?.querySelectorAll(".filter__item .form-check-input");
    const applyBtn = filterNodes.parent?.querySelector('[data-applyFilters]');
      this.filterItems?.forEach(item => {
        item.addEventListener("change", () => {
          const checkedCount = Array.from(this.filterItems).filter(checkbox => checkbox.checked).length;
        
            if (applyBtn.classList.contains("d-none")) {
              applyBtn.classList.remove("d-none");
            }
            if (checkedCount < 1) {
              applyBtn.classList.add("d-none");
            }
        });
      });
  }
  
  /**
   * Update the url
   * @param {String} searchParams 
   */

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  /**
   * 
   * @param {event} event 
   */
  updateSortBy(event){
    let currentEle = event.currentTarget;
    let targetOpt = this.filterForm.querySelector(`input[name="sort_by"][value="${currentEle.value}"]`);
    if(targetOpt){
      targetOpt.checked = true;
      this.onSubmitHandler(event);
    }
  }

  /**
   * 
   * @param {event} event 
   */
  _manageSubCollections(event){
    event.preventDefault();
    const _this =  event.currentTarget;
    const queryString = this._createQueryString(this.filterForm);
    let collURL = _this.href + '?' + queryString;
  
    this.renderGridFromFetch(collURL, 'sub_collection');

    setTimeout(() => {
      filterNodes.subCollectionLinks.forEach(link => link.classList.remove('active'));
      _this.classList.add('active');
      history.pushState({}, '', collURL);
    }, 500);
  }

  /**
   * 
   * @param {event} event 
   */
  _managePagination(event){
    event.preventDefault();
    let _this = event.currentTarget;
    this.renderGridFromFetch(_this.href, 'pagination');

    let paginationType = _this.closest('[data-paginationparent]').dataset.type;
    if(paginationType != 'loadmore'){
      setTimeout(() => {
        history.pushState({}, '', _this.href);
      }, 500);
    }
  }

  /**
   * Toggle Filter drawer
   * @param {event} event 
   */
  toggleFilterDrawer(event){
    event.preventDefault();
    let button = event.currentTarget;
    if(button.id == 'filter-drawer'){
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      filterNodes.parent.classList.add('filter-active');

      Utility.trapFocus(filterNodes.parent);
      Utility.forceFocus(filterNodes.closeDrawer);
      siteOverlay.prototype.showOverlay();
    }else{
      filterNodes.parent.classList.remove('filter-active');
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }
      if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(filterNodes.parent);
      siteOverlay.prototype.hideOverlay();
    }
  }
}
typeof CollectionFilters !== 'undefined' && new CollectionFilters();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  /**
   * 
   * @param {event} event 
   */
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    let form = this.closest('form');
    let sliderSections = this.getElementsByClassName("range-slider");
    
    for(const element of sliderSections){
      let sliders = element.getElementsByTagName("input");
      for(const element of sliders){
        if(element.type ==="range" ){
          element.oninput = _this.getVals;
          element.oninput();
          if(form && form.id == 'CollectionFiltersForm'){
            element.onchange = (_evt)=>{
              if(window.innerWidth >= 992) form.dispatchEvent(new CustomEvent('submit'));
            } 
          }
        }
      }
    }
  }
  
  // Get Price value from both range slider
  getVals(){
    let parent = this.parentNode;
    let slides = parent.getElementsByTagName("input");
    let slide1 = parseFloat(slides[0].value);
    let slide2 = parseFloat(slides[1].value);
      
    // Neither slider will clip the other, so make sure we determine which is larger
    if( slide1 > slide2 ){ let tmp = slide2; slide2 = slide1; slide1 = tmp; }
    
    let displayElement = parent.getElementsByClassName("rangeValues")[0];
    displayElement.innerHTML = Utility.formatMoney((slide1*100), `${window.globalVariables.money_format} - ${Utility.formatMoney((slide2*100), window.globalVariables.money_format)}`);
  }
}
customElements.define('range-slider', PriceRangeSlider);